import filterListJson from '@/assets/filterList.json';
import { useClusterSiteKitStore } from '@/stores/clusterSiteKitStore';
import { useStatsStore } from '@/stores/statsStore';
import { defineStore } from 'pinia';
import { useAdminStore } from './adminStore';

export const useFileFilterStore = defineStore('fileFilter', {
	state: () => ({
		selectedOrderTimeFilter: '',
		selectedDateFilter: '',
		selectedMoveModalOrderTimeFilter: '',
		selectedMoveModalDateFilter: '',
		selectedStatusFilter: '',
		selectedFileStatusFilter:'',
		selectedClusterFilter: '',
		selectedSiteFilter: '',
		selectedKitFilter: '',
		selectedCountryFilter: '',
		selectedDisciplineFilter: '',
		selectedFileProcessFilter: '',
		selectedActionTypeFilter: '',
		selectedRoleFilter: '',
		showFolderNoFiles: true,
		disciplines: [] as string[],
		countries: [] as string[],
		filterList: filterListJson as any[],
	}),

	actions: {
		isAnyFilterActive(): boolean {
			return this.filterList.some((filter) => {
				const firstValue = filter.options[0]?.value ?? null;
				return (this as Record<string, any>)[filter.target] !== firstValue;
			});
		},

		async loadFilterOptions() {
            const clusterSiteKitStore = useClusterSiteKitStore();
            const statsStore = useStatsStore();
            const adminStore = useAdminStore();

            if (!clusterSiteKitStore.clusters.length) {
                await clusterSiteKitStore.fetchClusterData(100,true);
            }
            if (!clusterSiteKitStore.sites.length) {
                await clusterSiteKitStore.fetchSiteData(100,true);
            }
            if (!clusterSiteKitStore.kits.length) {
                await clusterSiteKitStore.fetchKitData(100,true);
            }
            if (!statsStore.disciplines.length || !statsStore.countries.length) {
                await statsStore.fetchDisciplinesAndCountries();
            }

            const dynamicOptionsMap: Record<string, { items: any[], getText: (item: any) => string, getValue: (item: any) => any }> = {
                selectedClusterFilter: {
                    items: clusterSiteKitStore.clusters,
                    getText: (c) => c.name,
                    getValue: (c) => c.id,
                },
                selectedSiteFilter: {
                    items: clusterSiteKitStore.sites,
                    getText: (s) => s.name,
                    getValue: (s) => s.id,
                },
                selectedKitFilter: {
                    items: clusterSiteKitStore.kits,
                    getText: (k) => k.name,
                    getValue: (k) => k.id,
                },
                selectedCountryFilter: {
                    items: statsStore.countries,
                    getText: (c) => c,
                    getValue: (c) => c,
                },
                selectedDisciplineFilter: {
                    items: statsStore.disciplines,
                    getText: (d) => d,
                    getValue: (d) => d,
                },
                selectedActionTypeFilter: {
                    items: adminStore.actionTypes,
                    getText: (type) => 'actions.' + type,
                    getValue: (type) => type,
                },
            };

            this.filterList.forEach((filter) => {
                const dynamic = dynamicOptionsMap[filter.target];
                if (dynamic) {
                    filter.options = [
                        { text: 'folder-list.all', value: '' },
                        ...dynamic.items.map((item) => ({
                            text: dynamic.getText(item),
                            value: dynamic.getValue(item),
                        })),
                    ];
                }
            });
        },
	},
});
